import * as yup from "yup";

export const MER_EDIT_FORM_SCHEMA = yup.object({
  username: yup.string().required("Korisničko ime je obavezno"),
  password: yup.string().required("Lozinka je obavezna"),
  companyId: yup.string().required("OIB je obavezan").matches(/^\d{11}$/, "OIB mora imati 11 znamenki"),
});
